import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function BreadcrumbNav({ items = [], dark = false }) {
  return (
    <nav className={`text-xs ${dark ? "text-gray-300" : "text-gray-600"}`} aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${it.label}-${i}`} className="flex items-center gap-1">
              {last || !it.to ? (
                <span className={`${dark ? "text-br-bronze-2" : "text-br-bronze"} font-semibold"`}>{it.label}</span>
              ) : (
                <Link className={`hover:text-br-bronze`} to={it.to}>{it.label}</Link>
              )}
              {!last && <ChevronRight size={12} className="opacity-60" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
